import React, { Component } from 'react';
import { Container, Typography, FormControl, RadioGroup, Radio, FormControlLabel, TextField } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete';

//Above this many databases, a searchable pulldown is used instead of radio buttons
const MAX_RADIO_DATABASES = 12;

    
/**
 *  The SwitchDatabasePage provides a radio-button list of available databases to select from, or a searchable pulldown 
 *  when there are more than MAX_RADIO_DATABASES. 
 *  
 *  The parent component MUST pass in a prop called selectDatabaseCallback which is a function that takes a parameter which is a String value
 *  of the database name selected.  The callback is invoked with the user selects one of databases
 * 
 *  The parent component MUST pass in a prop called availableDatabases which is an array of Strings with the database names. 
 *  
 *  The parent component MUST pass in a prop called selectedDatabase which is the String of the currently selected database
 * 
 */
    
    

export class SwitchDatabasePage extends Component {
  
  
    styles = {
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%'
        }
    }
  
  
    state = {
        selectedDatabase: undefined
    }

    constructor(props) {
        super(props);
        this.state.selectedDatabase = props.selectedDatabase;
    }


    /**
     * Callback when new radio button is selected. Set the current state of the radio button group selection, and callback to the parent
     * to tell them the database name has changed
     * @param {Object} event that fired the change 
     */
    _handleSelectDatabase = (event) => {
        const databaseName = event.target.value;
        this.setState({selectedDatabase: databaseName});
        this.props.selectDatabaseCallback(databaseName);
    };
    
    /**
     * Callback when a database is chosen from the pulldown. Ignore clearing (null), since a database must always be selected.
     * @param {Object} event that fired the change
     * @param {String} databaseName the chosen database, or null if cleared
     */
    _handleAutocompleteSelect = (event, databaseName) => {
        if (!databaseName)
            return;
        this.setState({selectedDatabase: databaseName});
        this.props.selectDatabaseCallback(databaseName);
    };


    render() {
        
        const databases = this.props.availableDatabases.filter((database) => database !== "admin");
        const selectedInList = databases.includes(this.state.selectedDatabase) ? this.state.selectedDatabase : null;

        const selector = databases.length > MAX_RADIO_DATABASES ?
            <Autocomplete
                size='small'
                value={selectedInList}
                onChange={this._handleAutocompleteSelect}
                options={databases}
                style={{ width: 300 }}
                blurOnSelect
                disableClearable
                renderInput={(params) => <TextField {...params} label="Database" variant="outlined" InputLabelProps={{ shrink: true }} />}
            /> 
            :
            <FormControl component="fieldset">
                <RadioGroup aria-label="database" name="selectedDatabase" value={this.state.selectedDatabase} onChange={this._handleSelectDatabase}>
                    {databases.map((database) =>                      
                        <FormControlLabel key={database} value={database} control={<Radio color="primary" />} label={database} />
                    )}
                </RadioGroup>
            </FormControl>;

        return (
            
            <Container >

                    <Typography variant="h5" style={{textAlign: 'center', paddingBottom: 20}}>Select Working Database</Typography>
                    <Container style={this.styles.container}>
                        {selector}
                    </Container>

            </Container>
        );

    }
    
}